export default "__VITE_ASSET__C8BTVwy2__"